import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export const useGetPlantUsersQuery = ({
  plantId,
  enabled = true,
}: {
  plantId: string;
  enabled?: boolean;
}) => {
  return useQuery<{ userIds: string[] }>({
    queryKey: ['plants', plantId, 'users'],
    queryFn: async () => {
      const { data } = await client.get<{ body: { userIds: string[] } }>(
        `/plants/${plantId}/users`
      );

      return data.body;
    },
    retry: 1,
    enabled,
  });
};
